import { ReactNode } from "react";

export const WhitePane: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="flex h-full w-full min-w-[1000px] items-center justify-center rounded-lg border border-gray-200 bg-white">
      {children}
    </div>
  );
};
